import { updateData, EFFECT_ERROR } from 'crustate';

var CUSTOMER_SYNC = "customer/sync";
var CUSTOMER_INIT_REQUEST = "customer/init/request";
var CUSTOMER_INIT_RESPONSE = "customer/init/response";
var CUSTOMER_LOGIN_REQUEST = "customer/login/request";
var CUSTOMER_LOGIN_RESPONSE = "customer/login/response";
var CUSTOMER_LOGOUT_REQUEST = "customer/logout/request";
var CUSTOMER_LOGOUT_RESPONSE = "customer/logout/response";
var CUSTOMER_SAVE_BILLING_ADDRESS_REQUEST = "customer/save_billing_address/request";
var CUSTOMER_SAVE_BILLING_ADDRESS_RESPONSE = "customer/save_billing_address/response";
var CUSTOMER_SAVE_SHIPPING_ADDRESS_REQUEST = "customer/save_shipping_address/request";
var CUSTOMER_SAVE_SHIPPING_ADDRESS_RESPONSE = "customer/save_shipping_address/response";
var CUSTOMER_RESET_PASSWORD_REQUEST = "customer/reset_password/request";
var CUSTOMER_RESET_PASSWORD_RESPONSE = "customer/reset_password/response";

// Actions
var syncCustomer = function syncCustomer(data) {
  return {
    tag: CUSTOMER_SYNC,
    data: data
  };
};
var logout = function logout() {
  return {
    tag: CUSTOMER_LOGOUT_REQUEST
  };
};
var login = function login(email, password) {
  return {
    tag: CUSTOMER_LOGIN_REQUEST,
    email: email,
    password: password
  };
};
var saveBillingAddress = function saveBillingAddress(address) {
  return {
    tag: CUSTOMER_SAVE_BILLING_ADDRESS_REQUEST,
    address: address
  };
};
var saveShippingAddress = function saveShippingAddress(address) {
  return {
    tag: CUSTOMER_SAVE_SHIPPING_ADDRESS_REQUEST,
    address: address
  };
};
var resetPassword = function resetPassword(email) {
  return {
    tag: CUSTOMER_RESET_PASSWORD_REQUEST,
    email: email
  };
};
var CustomerModel = {
  id: "customer",
  init: function init() {
    return updateData({
      state: "INITING"
    }, {
      tag: CUSTOMER_INIT_REQUEST
    });
  },
  update: function update(state, msg) {
    switch (msg.tag) {
      case EFFECT_ERROR:
        if ([CUSTOMER_LOGIN_REQUEST, CUSTOMER_LOGOUT_REQUEST, CUSTOMER_INIT_REQUEST].includes(msg.cause.tag)) {
          return updateData({
            state: "NOT_LOGGED_IN"
          });
        }
        return null;
      case CUSTOMER_SYNC:
        return msg.data ? updateData({
          state: "LOGGED_IN",
          data: msg.data
        }) : updateData({
          state: "NOT_LOGGED_IN"
        });
      case CUSTOMER_INIT_RESPONSE:
        if (state.state === "INITING" || state.state === "NOT_LOGGED_IN") {
          return msg.data ? updateData({
            state: "LOGGED_IN",
            data: msg.data
          }) : updateData({
            state: "NOT_LOGGED_IN"
          });
        }
        throw new Error("Invalid state transition");
      case CUSTOMER_LOGIN_REQUEST:
        if (state.state === "NOT_LOGGED_IN") {
          return updateData({
            state: "LOGGING_IN"
          }, msg);
        }
        throw new Error("Invalid state transition");
      case CUSTOMER_LOGIN_RESPONSE:
        if (state.state === "LOGGING_IN") {
          return msg.data ? updateData({
            state: "LOGGED_IN",
            data: msg.data
          }) : updateData({
            state: "NOT_LOGGED_IN"
          });
        }
        throw new Error("Invalid state transition");
      case CUSTOMER_SAVE_BILLING_ADDRESS_RESPONSE:
      case CUSTOMER_SAVE_SHIPPING_ADDRESS_RESPONSE:
        if (state.state === "SAVING_ADDRESS") {
          return updateData({
            state: "LOGGED_IN",
            data: msg.data
          });
        }
        throw new Error("Invalid state transition");
      case CUSTOMER_SAVE_BILLING_ADDRESS_REQUEST:
      case CUSTOMER_SAVE_SHIPPING_ADDRESS_REQUEST:
        if (state.state === "LOGGED_IN") {
          return updateData({
            state: "SAVING_ADDRESS",
            data: state.data
          }, msg);
        }
        throw new Error("Invalid state transition");
      case CUSTOMER_LOGOUT_REQUEST:
        if (state.state === "LOGGED_IN") {
          return updateData({
            state: "LOGGING_OUT",
            data: state.data
          }, msg);
        }
        throw new Error("Invalid state transition");
      case CUSTOMER_LOGOUT_RESPONSE:
        if (state.state === "LOGGING_OUT") {
          return updateData({
            state: "NOT_LOGGED_IN"
          });
        }
        throw new Error("Invalid state transition");
      case CUSTOMER_RESET_PASSWORD_REQUEST:
        return updateData({
          state: "RESET_PASSWORD"
        }, msg);
      case CUSTOMER_RESET_PASSWORD_RESPONSE:
        if (state.state === "RESET_PASSWORD") {
          return updateData({
            state: "NOT_LOGGED_IN"
          });
        }
        throw new Error("Invalid state transition");
      default:
    }
  }
};
var getCustomerData = function getCustomerData(d) {
  if (d.data !== null) {
    return d.data;
  }
  return null;
};

export { CUSTOMER_INIT_REQUEST, CUSTOMER_INIT_RESPONSE, CUSTOMER_LOGIN_REQUEST, CUSTOMER_LOGIN_RESPONSE, CUSTOMER_LOGOUT_REQUEST, CUSTOMER_LOGOUT_RESPONSE, CUSTOMER_RESET_PASSWORD_REQUEST, CUSTOMER_RESET_PASSWORD_RESPONSE, CUSTOMER_SAVE_BILLING_ADDRESS_REQUEST, CUSTOMER_SAVE_BILLING_ADDRESS_RESPONSE, CUSTOMER_SAVE_SHIPPING_ADDRESS_REQUEST, CUSTOMER_SAVE_SHIPPING_ADDRESS_RESPONSE, CUSTOMER_SYNC, CustomerModel, getCustomerData, login, logout, resetPassword, saveBillingAddress, saveShippingAddress, syncCustomer };
//# sourceMappingURL=index.esm.js.map
